//
import request from "root/js/request";

const getPostingReturnDiagramTopTenOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  group_by,
  reverse,
}) => {
  const response = await request({
    url: "/ozon_analytics/posting_return/diagram/top_ten/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      reverse,
      group_by,
    },
  });
  return response.data;
};

export { getPostingReturnDiagramTopTenOzon };
